import Cookiebar from './../html/cookiebar';
import Consentform from './../html/form';
// import Consentmodal from './../html/modal';

import Cookies from 'js-cookie';

export default class ConsentController {
    constructor() {
        if (Cookies.get('AVGPermissions')) {
            this.AVGCookie = JSON.parse(Cookies.get('AVGPermissions'));
        }
        this.configPromise = null;

        this.cookiebar = document.querySelector('.consent-cookiebar');
        if (!this.cookiebar) {
            this.createCookiebar();
            this.cookiebar = document.querySelector('.consent-cookiebar');
        }

        this.loadGTM();
        this.initCookiebar();
        this.initForm();

        if (this.AVGCookie) {
            this.update(this.functional, this.analytics, this.tracking);
        }
    }

    get functional() {
        if (this.AVGCookie === undefined) {
            return true;
        }
        return this.AVGCookie.Functional;
    }

    get analytics() {
        if (this.AVGCookie === undefined) {
            return false;
        }
        return this.AVGCookie.Analytics;
    }

    get tracking() {
        if (this.AVGCookie === undefined) {
            return false;
        }
        return this.AVGCookie.Tracking;
    }

    initCookiebar() {
        if (this.cookiebar) {
            this.cookiebar.querySelectorAll(`[data-agree]`).forEach(button => {
                button.addEventListener(`click`, this.agreeAll.bind(this));
            });
            this.cookiebar.querySelectorAll(`[data-refuse]`).forEach(button => {
                button.addEventListener(`click`, this.refuseAll.bind(this));
            });
            /* if (this.cookiebar.dataset.modal && this.cookiebar.dataset.modal == "true") {
                this.prepareConfigModal();
            } */
        }
        this.checkCookiebarState();
    }

    /**
     * Form should only be loaded on the page where the user can change their preferences
     */
    initForm() {
        document.querySelectorAll(`[data-consent-form]`).forEach(dataElement => {
            const data = dataElement.dataset;
            const props = {
                title: data.consentTitle,
                labelFunctional: data.consentLabelFunctional,
                textFunctional: dataElement.querySelector(`[data-consent-text-functional]`) ? dataElement.querySelector(`[data-consent-text-functional]`).innerHTML : ``,
                labelAnalytics: data.consentLabelAnalytics,
                textAnalytics: dataElement.querySelector(`[data-consent-text-analytics]`) ? dataElement.querySelector(`[data-consent-text-analytics]`).innerHTML : ``,
                labelTracking: data.consentLabelTracking,
                textTracking: dataElement.querySelector(`[data-consent-text-tracking]`) ? dataElement.querySelector(`[data-consent-text-tracking]`).innerHTML : ``,
                labelSave: data.consentLabelSave,
                textSuccess: data.consentSuccess,
                analyticsChecked: this.analytics,
                trackingChecked: this.tracking,
            };
            const consentform = Consentform(props);
            dataElement.parentElement.insertBefore(consentform, dataElement);
            dataElement.remove();

            consentform.querySelector(`[data-save]`).addEventListener(`click`, (e) => {
                e.preventDefault();
                this.update(
                    consentform.querySelector(`[name="functional"]`).checked,
                    consentform.querySelector(`[name="analytics"]`).checked,
                    consentform.querySelector(`[name="tracking"]`).checked,
                );
                this.checkCookiebarState();
                if (consentform.querySelector(`.successText`)) {
                    consentform.querySelector(`.successText`).classList.add(`saved`);
                    setTimeout(() => {
                        consentform.querySelector(`.successText`).classList.remove(`saved`);
                    }, 1500);
                }
            });
        });

    }

    /**
     * Handles saving cookie and updating GTM accordingly
     * @param {Boolean} functional 
     * @param {Boolean} analytics 
     * @param {Boolean} tracking 
     */
    update(functional, analytics, tracking) {
        if (functional !== undefined && analytics !== undefined && tracking !== undefined) {
            this.AVGCookie = {
                Functional: functional,
                Analytics: analytics,
			    Tracking: tracking,
            };

            // Google Consent v2
            const consent = this.consentDefaults;
            if (this.tracking) {
                consent.ad_personalization = `granted`;
                consent.ad_storage = `granted`;
                consent.ad_user_data = `granted`;
                consent.personalization_storage = `granted`;
            }

            if (this.analytics) {
                consent.analytics_storage = `granted`;
            }

            window.gtag(`consent`, `update`, consent);

            window.dataLayer.push({
                "Analytics": this.analytics,
                "Tracking": this.tracking,
                "event": "ChangeCookieChoices"
            });

            Cookies.set('AVGPermissions', JSON.stringify(this.AVGCookie), {
                expires: 99999
            });
        }
    }

    agreeAll() {
        this.update(true, true, true);
        this.checkCookiebarState();
    }

    refuseAll() {
        this.update(true, false, false);
        this.checkCookiebarState();
    }

    prepareConfigModal() {
        const configButton = this.cookiebar.querySelector(`a[data-change][href]`);
        if (configButton) {
            const target = configButton.href;
            fetch(target).then(response => {
                if (response.ok) {
                    return response.text();
                }
            }).then(htmlString => {
                const targetDOM = (new DOMParser()).parseFromString(htmlString, `text/html`);
                // if (targetDOM.querySelector())
            });
        }
    }



    /* prepareConfigModal() {
        setTimeout(() => {
            if (this.cookiebar.classList.contains(`open`) && this.cookiebar.querySelector(`a[data-change][href]`)) {
                const configButton = this.cookiebar.querySelector(`a[data-change][href]`);
                const target = configButton.href;
                
                this.configPromise = fetch(target).then(response => {
                    return response.text()
                }).then(htmlString => {
                    const parser = new DOMParser();
                    const DOM = parser.parseFromString(htmlString, `text/html`);
                    if (DOM.querySelector(`[data-consent-form]`)) {
                        // TODO
                    }
                });
            }
        }, 500);
    } */

    checkCookiebarState() {
        if (!document.querySelector(`[data-consent-form]`)) {
            if (this.AVGCookie === undefined) {
                this.cookiebar.classList.add(`open`);
                this.cookiebar.setAttribute(`open`, `open`);
            } else {
                this.cookiebar.classList.remove(`open`);
                this.cookiebar.removeAttribute(`open`);
            }
        }
    }

    loadGTM() {
        window.dataLayer = window.dataLayer || [];
        window.gtag = function(){window.dataLayer.push(arguments)};

        this.setDefaultConsent();
        document.querySelectorAll('noscript[data-gtm-tag]').forEach(noscript => {
            (function (w, d, s, l, i) {
                w[l] = w[l] || [];
                w[l].push({
                    'gtm.start': new Date().getTime(),
                    event: 'gtm.js'
                });
                var f = d.getElementsByTagName(s)[0],
                    j = d.createElement(s),
                    dl = l != 'dataLayer' ? '&l=' + l : '';
                j.async = true;
                j.src =
                    'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                f.parentNode.insertBefore(j, f);
            })
            (window, document, 'script', 'dataLayer', noscript.dataset.gtmTag);
		});
    }

    get consentDefaults() {
        const consent = {
            ad_storage: `denied`,
            ad_user_data: `denied`,
            ad_personalization: `denied`,
            analytics_storage: `denied`,
            personalization_storage: `denied`,
            functionality_storage: `granted`,
            security_storage: `granted`,
        };

        if (this.tracking) {
            consent.ad_personalization = `granted`;
            consent.ad_storage = `granted`;
            consent.ad_user_data = `granted`;
            consent.personalization_storage = `granted`;
        }

        if (this.analytics) {
            consent.analytics_storage = `granted`;
        }

        return consent;
    }

    setDefaultConsent() {
        window.gtag(`consent`, `default`, this.consentDefaults);
    }

    /**
     * @description Creates and inserts a custom cookiebar based on a div with data on the webpage
     */
    createCookiebar() {
        const dataElement = document.querySelector(`[data-consent]`);
        if (dataElement) {
            const data = dataElement.dataset;
            const props = {
                title: data.consentTitle,
                textMobile: dataElement.querySelector(`[data-consent-text-mobile]`) ? dataElement.querySelector(`[data-consent-text-mobile]`).innerHTML : "",
                textDesktop: dataElement.querySelector(`[data-consent-text-desktop]`) ? dataElement.querySelector(`[data-consent-text-desktop]`).innerHTML : "",
                textButtonAgree: data.consentButtonAgree,
                textButtonChange: data.consentButtonChange,
                allowChange: data.consentAllowChange && data.consentAllowChange.toLowerCase() == "true",
                changeUrl: data.consentChangeUrl,
                textButtonRefuse: data.consentButtonRefuse,
                allowRefuse: data.consentAllowRefuse && data.consentAllowRefuse.toLowerCase() == "true",
                useModal: data.consentUseModal && data.consentUseModal.toLowerCase() == "true",
            };
    
            const cookiebar = Cookiebar(props);
            if (cookiebar) {
                dataElement.parentElement.insertBefore(cookiebar, dataElement);
                dataElement.remove();
            }
        }
    }
}